import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIsolateAction = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3333 16.3333H4.66667V4.66667H16.3333V16.3333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.33334 18.6667L4.95833 18.6667V21H6.67572e-06V16.0417H2.33334V18.6667Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.125 21H7.875V18.6667L13.125 18.6667V21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 21H16.0417V18.6667H18.6667V16.0417H21V21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.33333 13.125H6.67572e-06L0 7.875H2.33333V13.125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 13.125H18.6667V7.875H21V13.125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.95833 2.33333H2.33333V4.95833H0V2.78155e-07L4.95833 0V2.33333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 4.95833H18.6667V2.33333L16.0417 2.33336V0H21V4.95833Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.125 2.33336H7.875V2.39213e-05L13.125 0V2.33336Z",
			fill: "currentColor"
		})
	]
});
export default SvgIsolateAction;
